import PositionApplicants from './PositionApplicants';

export default PositionApplicants;
